import { AppBar, Box, Button, Stack, Toolbar, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

// Since we can't use local imports, we'll need to replace the logo with a URL
// In a real implementation, you would use a proper image URL
// const LOGO_PLACEHOLDER = "https://via.placeholder.com/48";
import LOGO_PLACEHOLDER from "../assets/img/logo-nav.png";

// Styled components
const NavLink = styled(Typography)(({ theme }) => ({
  fontFamily: "'Space Grotesk', sans-serif",
  fontWeight: 400,
  color: "#7c611c",
  fontSize: 16,
  lineHeight: "16px",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
}));

const LogoText = styled(Typography)(({ theme }) => ({
  fontFamily: "'DM Serif Display', serif",
  fontWeight: 400,
  color: "black",
  fontSize: 24,
  lineHeight: "24px",
  whiteSpace: "nowrap",
}));

const FaqButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#020202",
  color: "#bab7a9",
  borderRadius: "34px",
  textTransform: "none",
  padding: "0 20px",
  height: 40,
  fontFamily: "'Inter', sans-serif",
  fontSize: 16,
  "&:hover": {
    backgroundColor: "#333333",
  },
}));

const NavigationSection = () => {
  // Navigation links data
  const navLinks = [
    // { label: "Home", path: "#" },
    // { label: "Services", path: "#about" },
    // { label: "Products", path: "/products" },
    // { label: "Contact", path: "/contact" },
  ];

  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      sx={{
        height: 70,
        justifyContent: "center",
      }}
    >
      <Toolbar
        sx={{ px: { xs: 2, md: 12.5 }, justifyContent: "space-between" }}
      >
        {/* Logo and brand name */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            component="img"
            src={LOGO_PLACEHOLDER}
            alt="Arkyn-tech logo"
            sx={{ width: 48, height: 48, objectFit: "cover" }}
          />
          <LogoText>Arkyn-tech</LogoText>
        </Stack>

        {/* Navigation links and FAQ button */}
        <Stack direction="row" alignItems="center" spacing={3.75}>
          {navLinks.map((link, index) => (
            <NavLink key={index}>{link.label}</NavLink>
          ))}
          <FaqButton onClick={() => {
                const section = document.getElementById("order-now-section");
                if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                }
            }}>
                Order now
            </FaqButton>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationSection;